import parse from 'html-react-parser'
import { useMemo } from 'react'
import { IconButton, Typography } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { Attachments, textToHtml } from 'widgets/MessageField'
import { useSavedRepliesContext } from 'pages/settings/pages/savedReplies/context/savedRepliesContext'

import styles from './styles.module.scss'

export const PreviewSavedReplyContent = () => {
  const {
    selectedSavedReply,
    newSavedReplyStore: {
      messageFieldStore: {
        messageRemainsInfo: { messageCount, messageRemains },
      },
    },
  } = useSavedRepliesContext()
  const entities = useEntitiesContext()

  const message = useMemo(() => {
    if (selectedSavedReply?.message) {
      return parse(
        textToHtml(entities, {
          text: selectedSavedReply.message,
          replaceNewRow: true,
        })
      )
    }
  }, [selectedSavedReply])

  return (
    <div className={styles.wrapContent}>
      {!!selectedSavedReply?.attachments?.length && (
        <div className={styles.wrapAttachments}>
          <Attachments attachments={selectedSavedReply.attachments} />
        </div>
      )}
      <Typography
        variant={'body-rg-regular'}
        className={styles.message}
        tag={'div'}
        ariaLabel={'message'}
      >
        {message}
      </Typography>
      <div className={styles.wrapActions}>
        <div className={styles.actions}>
          <IconButton ariaLabel='addMedia' icon={'addCircle'} variant='icon' disabled />
          <IconButton ariaLabel='addEmoji' icon={'emoji'} variant='icon' disabled />
          <IconButton ariaLabel='addMergeField' icon={'user'} variant='icon' disabled />
          <IconButton ariaLabel='addShortLink' icon={'link'} variant='icon' disabled />
        </div>
        <Typography
          variant='text-input-helper'
          tag='div'
          ariaLabel='MessageCount'
          color='var(--content-primary-disabled)'
        >
          {messageCount}/{messageRemains}
        </Typography>
      </div>
    </div>
  )
}
